import Window from "pages/Mac/Window";
import React, { useMemo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

export default function TextEdit({ data }) {
  const memoized = useMemo(
    () => (
      <div className="component-textedit" onClick={() => console.log("click")}>
        <ReactMarkdown
          children={markdown}
          components={{
            a: ({ node, ...props }) => {
              return (
                <a {...props} href={node.properties.href} target="_blank" />
              );
            },
          }}
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}
        />
      </div>
    ),
    []
  );
  return (
    <Window {...data} name="README.md">
      {() => {
        return memoized;
      }}
    </Window>
  );
}

const markdown = `
### Sung Woo Park - @ggomaeng

[![Hits](https://hits.seeyoufarm.com/api/count/incr/badge.svg?url=https%3A%2F%2Fgithub.com%2Fggomaeng)](https://github.com/ggomaeng)
[![Facebook Badge](https://img.shields.io/badge/-Facebook-1877f2?style=flat-square&logo=facebook&logoColor=white&link=https://www.facebook.com/ssung.p)](https://www.facebook.com/ssung.p)
[![Linkedin Badge](https://img.shields.io/badge/-LinkedIn-blue?style=flat-square&logo=Linkedin&logoColor=white&link=https://www.linkedin.com/in/sungwoopark95//)](https://www.linkedin.com/in/sungwoopark95//)
[![Gmail Badge](https://img.shields.io/badge/-Gmail-d14836?style=flat-square&logo=Gmail&logoColor=white&link=mailto:sungwoopark95@gmail.com)](mailto:sungwoopark95@gmail.com)

Hello there! 👋

I am the Co-founder of [Sketchware](https://play.google.com/store/apps/details?id=com.besome.sketch). I am currently working as a Front-end Engineer at HUNT, where I'm turning coffee into code.

### 🎓 Education

- Johns Hopkins University, Bloomberg Scholar (2014-2019)

---

### 🖤 Hackathon Experiences

#### 2020

- **2nd Place** - [LOLHunt](https://devpost.com/software/lol-hunt) at Blockstack - Online Hackathon

#### 2019

- **1st Place** - [Intime](https://medium.com/luniverse/2019-udc-hackathon-2cb1c6cc2b8) at Upbit UDC Hackathon, Seoul, KR

#### 2018

- **1st Place** - [MediBlock](https://devpost.com/software/mediblock) at Hophacks - Johns Hopkins Hackathon, Baltimore, MD

#### 2017

- **Finalist** - [BitOne](https://devpost.com/software/bitone) at Hophacks - Johns Hopkins Hackathon, Baltimore, MD

- **Facebook - Judge's Choice** - [BitOne](https://devpost.com/software/bitone) at Hophacks - Johns Hopkins Hackathon, Baltimore, MD

- **Capital One - Best Financial Hack** - [BitOne](https://devpost.com/software/bitone) at Hophacks - Johns Hopkins Hackathon, Baltimore, MD

- **Deloitte - Best User Experience** - [BitOne](https://devpost.com/software/bitone) at Hophacks - Johns Hopkins Hackathon, Baltimore, MD

#### 2016

- **Finalist** - [TrustFall](https://devpost.com/software/trustfall-ghrtp8) at Hophacks - Johns Hopkins Hackathon, Baltimore, MD

- **Mission Data: Best User Experience** - [TrustFall](https://devpost.com/software/trustfall-ghrtp8) at Hophacks - Johns Hopkins Hackathon, Baltimore, MD

- **2nd Place** - [Emicus](https://devpost.com/software/emicus) at Medhacks - Johns Hopkins Medical Hackathon, Baltimore, MD

---

### 🥜 My Projects in a Nutshell

[Facebook UI Clone](https://github.com/ggomaeng/react-native-facebook-ui)

<a href="https://github.com/ggomaeng/react-native-facebook-ui">
<img src="https://raw.githubusercontent.com/ggomaeng/react-native-facebook-ui/master/demo.gif" height="400"/>
</a>

[Spotify UI Clone](https://github.com/ggomaeng/react-native-spotify-ui)

<a href="https://github.com/ggomaeng/react-native-spotify-ui">
<img src="https://raw.githubusercontent.com/ggomaeng/react-native-spotify-ui/master/demo.gif" height="400"/>
</a>

<details>
<summary>See More 👀</summary>
<p>
  

[Gmail UI Clone](https://github.com/ggomaeng/react-native-gmail)

<a href="https://github.com/ggomaeng/react-native-gmail">
<img src="https://raw.githubusercontent.com/ggomaeng/react-native-gmail/master/demo.gif" height="400"/>
</a>

[RN Tetris](https://github.com/ggomaeng/react-native-tetris)

<a href="https://github.com/ggomaeng/react-native-tetris">
<img src="https://raw.githubusercontent.com/ggomaeng/react-native-tetris/master/demo.gif" height="400"/>
</a>

[RN Card Modal](https://github.com/ggomaeng/react-native-card-modal)

<a href="https://github.com/ggomaeng/react-native-card-modal">
<img src="https://raw.githubusercontent.com/ggomaeng/react-native-card-modal/master/demo.gif" height="400"/>
</a>

[RN Product Page](https://github.com/ggomaeng/react-native-product-page)

<a href="https://github.com/ggomaeng/react-native-product-page">
<img src="https://raw.githubusercontent.com/ggomaeng/react-native-product-page/master/demo.gif" height="400"/>
</a>

[RN SVG Chicken](https://github.com/ggomaeng/react-native-svg-chicken)

<a href="https://github.com/ggomaeng/react-native-svg-chicken">
<img src="https://raw.githubusercontent.com/ggomaeng/react-native-svg-chicken/master/demo.gif" height="400"/>
</a>

[RN Solitaire](https://github.com/ggomaeng/react-native-solitaire)

<a href="https://github.com/ggomaeng/react-native-solitaire">
<img src="https://raw.githubusercontent.com/ggomaeng/react-native-solitaire/master/demo.gif" height="400"/>
</a>

[RN Listview](https://github.com/ggomaeng/react-native-magazine-listview)

<a href="https://github.com/ggomaeng/react-native-magazine-listview">
<img src="https://raw.githubusercontent.com/ggomaeng/react-native-magazine-listview/master/demo.gif" height="400"/>
</a>

[BitOne @ JHU Hackathon 2017](https://github.com/ggomaeng/hophacks2017)

<a href="https://github.com/ggomaeng/hophacks2017">
<img src="https://github.com/ggomaeng/hophacks2017/raw/master/screenshots/1.PNG" height="400"/>
</a>

<a href="https://github.com/ggomaeng/hophacks2017">
<img src="https://github.com/ggomaeng/hophacks2017/raw/master/screenshots/2.PNG" height="400"/>
</a>

<a href="https://github.com/ggomaeng/hophacks2017">
<img src="https://github.com/ggomaeng/hophacks2017/raw/master/screenshots/3.PNG" height="400"/>
</a>

<a href="https://github.com/ggomaeng/hophacks2017">
<img src="https://github.com/ggomaeng/hophacks2017/raw/master/screenshots/4.PNG" height="400"/>
</a>

<a href="https://github.com/ggomaeng/hophacks2017">
<img src="https://github.com/ggomaeng/hophacks2017/raw/master/screenshots/5.PNG" height="400"/>
</a>

<a href="https://github.com/ggomaeng/hophacks2017">
<img src="https://github.com/ggomaeng/hophacks2017/raw/master/screenshots/6.PNG" height="400"/>
</a>

[Emicus @ Medhacks 2016](https://devpost.com/software/emicus)

<a href="https://devpost.com/software/emicus">
<img src="http://sungwoopark.com/images/medhacks/3.jpg" height="400"/>
</a>

<a href="https://devpost.com/software/emicus">
<img src="http://sungwoopark.com/images/medhacks/4.gif" height="400"/>
</a>

</p>
</details>
`;
